import type { Plugin } from 'chart.js'

const PLUGIN_ID = 'recalculateBubbleRadiusOnResize'

// Chart.js resolves a scriptable `radius` option on bubble datasets once,
// at parse time, and caches it on the parsed point as `_custom` (see
// BubbleController#parsePrimitiveData in chart.js). Every later update -
// including a resize - reuses that cached value instead of re-invoking the
// scriptable function, so bubbles never grow/shrink on resize on their own.
// Reassigning each dataset's `data` array gives Chart.js a new reference,
// which makes it re-parse (and thus re-run the scriptable radius callback
// with the chart's now-current width) before the resize-triggered update
// that immediately follows this hook.
export const recalculateBubbleRadiusOnResize: Plugin<'bubble'> = {
  id: PLUGIN_ID,

  resize(chart) {
    chart.data.datasets.forEach((dataset) => {
      dataset.data = dataset.data.map((point) => ({ ...point }))
    })
  }
}
